import { useTheme } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NewEmail = () => {
  var {
    colors
  } = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    height: "100%",
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M127.5 122.49V63.3451C127.5 62.1301 126.949 60.9808 126.002 60.2208L74.5022 18.8824C73.04 17.7088 70.96 17.7088 69.4978 18.8824L17.9978 60.2208C17.051 60.9808 16.5 62.1301 16.5 63.3451V122.49C16.5 124.702 18.2909 126.495 20.5 126.495H123.5C125.709 126.495 127.5 124.702 127.5 122.49Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M73.2511 20.4446C72.52 19.8578 71.48 19.8578 70.7489 20.4446L19.2489 61.783C18.7755 62.163 18.5 62.7376 18.5 63.3451V122.49C18.5 123.596 19.3954 124.493 20.5 124.493H123.5C124.605 124.493 125.5 123.596 125.5 122.49V63.3451C125.5 62.7376 125.225 62.163 124.751 61.783L73.2511 20.4446ZM68.2467 17.3203C70.44 15.5599 73.5601 15.5599 75.7533 17.3204L127.253 58.6587C128.674 59.7988 129.5 61.5227 129.5 63.3451V122.49C129.5 125.808 126.814 128.497 123.5 128.497H20.5C17.1863 128.497 14.5 125.808 14.5 122.49V63.3451C14.5 61.5227 15.3265 59.7988 16.7467 58.6587L68.2467 17.3203Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      d: "M33.5 39.493C33.5 38.3872 34.3954 37.4907 35.5 37.4907H108.5C109.605 37.4907 110.5 38.3872 110.5 39.493V114.938C110.5 116.044 109.605 116.941 108.5 116.941H35.5C34.3954 116.941 33.5 116.044 33.5 114.938V39.493Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M31.5 39.493C31.5 37.2814 33.2909 35.4885 35.5 35.4885H108.5C110.709 35.4885 112.5 37.2814 112.5 39.493V114.939C112.5 117.15 110.709 118.943 108.5 118.943H35.5C33.2909 118.943 31.5 117.15 31.5 114.939V39.493ZM108.5 39.493L35.5 39.493V114.939L108.5 114.939V39.493Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.5 61.6274L58.514 94.0631L69.3928 85.8545C70.7897 84.8005 72.7086 84.7773 74.1304 85.7974L87.0421 95.0611L127.5 61.6274V126.998H16.5V61.6274Z",
      fill: colors.illustration.light
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M128.353 59.8163C129.053 60.1467 129.5 60.8523 129.5 61.6275V126.998C129.5 128.104 128.605 129 127.5 129H16.5C15.3954 129 14.5 128.104 14.5 126.998V61.6275C14.5 60.8643 14.9334 60.1674 15.6176 59.8307C16.3017 59.4939 17.1176 59.5759 17.7213 60.042L58.5279 91.5454L68.189 84.2556C70.2843 82.6746 73.1627 82.6399 75.2954 84.17L86.956 92.536L126.227 60.0834C126.824 59.5899 127.652 59.4858 128.353 59.8163ZM85.8398 96.6619L72.9654 87.425C72.2545 86.9149 71.295 86.9265 70.5966 87.4535L59.7324 95.651L22.2983 124.996H121.733L85.8398 96.6619ZM125.5 122.869L90.227 95.0255L125.5 65.8765V122.869ZM18.5 122.887V65.7L55.2545 94.0752L18.5 122.887Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      d: "M111 50.5C118.18 50.5 124 44.6797 124 37.5C124 30.3203 118.18 24.5 111 24.5C103.82 24.5 98 30.3203 98 37.5C98 44.6797 103.82 50.5 111 50.5Z",
      fill: colors.illustration.main
    })]
  });
};
//# sourceMappingURL=NewEmail.js.map